export default defineAppConfig({
  myLayer: {
    name: 'Hello from Store layer',
  },
})

declare module '@nuxt/schema' {
  interface AppConfigInput {
    myLayer?: {
      /** Project name */
      name?: string
    }
  }
}
